import { render, staticRenderFns } from "./Acl.vue?vue&type=template&id=52e4f20e&scoped=true&"
import script from "./Acl.vue?vue&type=script&lang=js&"
export * from "./Acl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e4f20e",
  null
  
)

export default component.exports